import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from './Hero';
import MissionStatement from './MissionStatement';
import Faq from './Faq';
import { Helmet } from 'react-helmet-async';

const LandingPage = () => {
    const location = useLocation();

    useEffect(() => {
        const scrollToSection = localStorage.getItem('scrollToSection');

        if (scrollToSection) {
            localStorage.removeItem('scrollToSection');

            const { state } = location;
            if (state?.scrollTo) {
                // WITH
                setTimeout(() => {
                    const element = document.getElementById(state.scrollTo);
                    if (element) {
                        const offset = 80;
                        const top = element.getBoundingClientRect().top + window.scrollY - offset;
                        window.scrollTo({ top, behavior: 'smooth' });
                    }
                }, 100);
            }
        }
    }, [location]);

    return (
        <div>
            <Helmet>
                <title>Market Rodeo - Stock Research Platform for Everyday Investors</title>
                <meta name="description" content="Track congressional trades, screen stocks with 90+ filters, monitor your portfolio, and get AI-powered research in seconds. Start free." />
                <meta property="og:title" content="Market Rodeo - Stock Research for Every Investor" />
                <meta property="og:description" content="Track congressional trades, screen stocks with 90+ filters, monitor your portfolio, and get AI-powered research. Start free." />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": [
                            {
                                "@type": "Question",
                                "name": "What is Market Rodeo?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Market Rodeo is a stock market research platform built for retail investors. It gives you access to market data, advanced stock screeners, portfolio tracking, AI-powered research through RodeoAI, and much more."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Do you offer a free plan?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Yes, we offer a free plan that allows you to try Market Rodeo before committing to a subscription. We also offer Basic and Premium plans with additional features."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Can I cancel my subscription anytime?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Yes, you can cancel at any time from your account settings. Your access continues until the end of your current billing period. No cancellation fees."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Can I track cryptocurrency prices on Market Rodeo?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Yes. Market Rodeo supports real-time cryptocurrency tracking with price data, charts, and market analysis alongside stocks and ETFs."
                                }
                            }
                        ]
                    })}
                </script>
            </Helmet>
            <Hero />
            <MissionStatement />
            <div id="faq">
                <Faq />
            </div>
        </div>
    );
};

export default LandingPage;